import { Dispatch } from 'redux';
import { actionCreators } from './AssetsState';
import { CategoryCountRequest } from '../../Interfaces/Assets/CategoryCountRequest';
import {
  SendToDivisionCommandInfo,
  SendToLanesCommandInfo,
  SendToNodeGroupsCommandInfo,
  SendToSiteNumbersCommandInfo,
} from '../../Interfaces/Commands/CommandInfo';
import { SendToDivisionsScheduledCommandInfo, SendToLanesScheduledCommandInfo, SendToNodeGroupsScheduledCommandInfo, SendToSiteNumbersScheduledCommandInfo } from '../../Interfaces/Commands/ScheduledCommandInfo';

export const resetAssetsState = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetState());
};

export const fetchStoreCount = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchStoreCount());
};

export const fetchNodeCount = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchNodeCount());
};

export const fetchActiveNodeTypeCounts = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchActiveNodeTypeCounts());
};

export const fetchCategoryCounts = async (
  dispatch: Dispatch<any>,
  categoryCountRequest: CategoryCountRequest
) => {
  return dispatch(actionCreators.fetchCategoryCounts(categoryCountRequest));
};

export const fetchSystemTypes = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchSystemTypes());
};

export const getNodeAssetsInfo = async (
  dispatch: Dispatch<any>,
  nodeId: number
) => {
  return dispatch(actionCreators.getNodeAssetsInfo(nodeId));
};

export const exportFilteredAssets = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.exportFilteredAssets());
};

export const getAllNodes = async (dispatch: Dispatch<any>, includeDecommissioned: boolean) => {
  return dispatch(actionCreators.getAllNodes(includeDecommissioned));
};

export const getAllNodesByPage = async (dispatch: Dispatch<any>, includeDecommissioned: boolean) => {
  return dispatch(actionCreators.getNodesByPage(includeDecommissioned));
};

export const resetNodesResult = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetNodesResult());
};

export const getAssetStoreList = async (dispatch: any) => {
  return dispatch(actionCreators.getAssetStoreList());
};
export const getAssetCategoryList = async (dispatch: any) => {
  return dispatch(actionCreators.getAssetCategoryList());
};

export const getAssetNameList = async (
  dispatch: any,
  assetCategory: string
) => {
  return dispatch(actionCreators.getAssetNameList(assetCategory));
};

export const getDivisionList = async (dispatch: any) => {
  return dispatch(actionCreators.getDivisionList());
};

export const getNodeTypeList = async (dispatch: any) => {
  return dispatch(actionCreators.getNodeTypeList());
};

export const resetFilteredAssets = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetFilteredAssets());
};

export const getLaneNumbers = async (dispatch: any) => {
  return dispatch(actionCreators.getLaneNumbers());
};

export const getNodeGroups = async (dispatch: any) => {
  return dispatch(actionCreators.getNodeGroups());
};

export const resetFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetFetchError());
};

export const getSiteNumberByDivision = async (
  dispatch: any,
  division: string
) => {
  return dispatch(actionCreators.getSiteNumberByDivision(division));
};

export const getNodeGroupByDivisionAndSiteNumber = async (
  dispatch: any,
  division: string,
  siteNumber: string
) => {
  return dispatch(
    actionCreators.getNodeGroupByDivisionAndSiteNumber(division, siteNumber)
  );
};

export const getLaneNumberByDivisionSiteNumberAndCluster = async (
  dispatch: any,
  division: string,
  siteNumber: string,
  cluster: string
) => {
  return dispatch(
    actionCreators.getLaneNumberByDivisionSiteNumberAndCluster(
      division,
      siteNumber,
      cluster
    )
  );
};

export const sendToSiteNumberCommand = async (
  dispatch: Dispatch<any>,
  sendToSiteNumbersCommandInfo: SendToSiteNumbersCommandInfo
) => {
  return dispatch(
    actionCreators.sendToSiteNumberCommand(sendToSiteNumbersCommandInfo)
  );
};

export const sendToNodeGroupsCommand = async (
  dispatch: Dispatch<any>,
  sendToNodeGroupsCommandInfo: SendToNodeGroupsCommandInfo
) => {
  return dispatch(
    actionCreators.sendToNodeGroupsCommand(sendToNodeGroupsCommandInfo)
  );
};

export const sendToLanesCommand = async (
  dispatch: Dispatch<any>,
  sendToLanesCommandInfo: SendToLanesCommandInfo
) => {
  return dispatch(actionCreators.sendToLanesCommand(sendToLanesCommandInfo));
};

export const sendToDivisionCommand = async (
  dispatch: Dispatch<any>,
  sendToDivisionCommandInfo: SendToDivisionCommandInfo
) => {
  return dispatch(
    actionCreators.sendToDivisionCommand(sendToDivisionCommandInfo)
  );
};

export const sendScheduledToSiteNumberCommand = async (
  dispatch: Dispatch<any>,
  sendScheduledToSiteNumbersCommandInfo: SendToSiteNumbersScheduledCommandInfo
) => {
  return dispatch(
    actionCreators.sendScheduledToSiteNumberCommand(sendScheduledToSiteNumbersCommandInfo)
  );
};

export const sendScheduledToNodeGroupsCommand = async (
  dispatch: Dispatch<any>,
  sendScheduledToNodeGroupsCommandInfo: SendToNodeGroupsScheduledCommandInfo
) => {
  return dispatch(
    actionCreators.sendScheduledToNodeGroupsCommand(sendScheduledToNodeGroupsCommandInfo)
  );
};

export const sendScheduledToLanesCommand = async (
  dispatch: Dispatch<any>,
  sendScheduledToLanesCommandInfo: SendToLanesScheduledCommandInfo
) => {
  return dispatch(actionCreators.sendScheduledToLanesCommand(sendScheduledToLanesCommandInfo));
};

export const sendScheduledToDivisionCommand = async (
  dispatch: Dispatch<any>,
  sendScheduledToDivisionCommandInfo: SendToDivisionsScheduledCommandInfo
) => {
  return dispatch(
    actionCreators.sendScheduledToDivisionCommand(sendScheduledToDivisionCommandInfo)
  );
};

export const clearSuccessMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.clearSuccessMessage());
};

export const reactivateNode = async (dispatch: Dispatch<any>, uuid: string) => {
  return dispatch(actionCreators.reactivateNode(uuid));
};

export const unregisterNode = async (dispatch: Dispatch<any>, uuid: string) => {
  return dispatch(actionCreators.unregisterNode(uuid));
};

export const resetAllSendCommandResult = async (
  dispatch: Dispatch<any>,
) => {
  return dispatch(actionCreators.resetAllSendCommandResult());
};